import RoofSnapApiClient from './roofSnapApiClient';

const baseUrl = "sketchtechsketchorders";

class SketchTechSketchOrderClient extends RoofSnapApiClient {
    async getAllSketchOrderCounts() {
        const url = `${baseUrl}/totals`;
        const sketchOrderCounts = await super.get(url);
        return sketchOrderCounts;
    }

    async getSketchOrders(params) {
        const { queryParams } = params;
        const url = `${baseUrl}${queryParams}`;
        const sketchOrders = await super.get(url);
        return sketchOrders;
    }

    async getSketchOrder(params) {
        const { id } = params;
        const url = `${baseUrl}/${id}`;
        const sketchOrder = await super.get(url);
        return sketchOrder;
    }

    async updateSketchOrder(params) {
        const { id, body, version } = params;
        const url = `${baseUrl}/${id}`;
        const sketchOrder = await super.update(url, body, version);
        return sketchOrder;
    }
    
    async deleteSketchOrderProject(params) {
        const { id } = params;
        const url = `${baseUrl}/${id}/project`;
        return await super.delete(url);
    }
}

export default SketchTechSketchOrderClient;